@if (show) {

  @defer (when show) {
    <ng-content></ng-content>
  } @placeholder {

  }
} @else {
  <div class="tmp-card">
    <ng-content select="[placeholder]"></ng-content>
    <div class="card-overlay">
      <div class="d-flex justify-content-center" style="height: 100%">
        <div class="d-flex align-items-center ">
          <div style="color: #edb948" class="la-pacman">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
    </div>
  </div>
}




